import { Box3, Vector3 } from 'three';

import { OctNodeI, OctTree } from './octTree';

interface DescriptorNode {
  xmin: number;
  xmax: number;
  ymin: number;
  ymax: number;
  zmin: number;
  zmax: number;

  geometry?: string;

  // resolution is currently not actively used in the system.
  // But we do not want to loose it as is it not possible to find post-creation
  resolution?: number;

  children: DescriptorNode[];
}

export interface GLTFTDescriptor {
  root: {
    geometry: string;
    children: DescriptorNode[];
  };
}

export const parseGLTFTDescriptorToOctTree = (
  descriptor: GLTFTDescriptor,
  offset: Vector3 = new Vector3(0, 0, 0),
): OctTree => {
  return new OctTree(descriptorNodeToOctNode(descriptor.root.children[0], offset));
};

const descriptorNodeToOctNode = (node: DescriptorNode, offset: Vector3): OctNodeI => {
  return {
    boundingBox: new Box3(
      new Vector3(node.xmin + offset.x, node.ymin + offset.y, node.zmin + offset.z),
      new Vector3(node.xmax + offset.x, node.ymax + offset.y, node.zmax + offset.z),
    ),
    children: node.children
      ? node.children.map((child) => descriptorNodeToOctNode(child, offset))
      : [],
    data: {
      geometry: node.geometry,
      pointcloud: node.geometry && node.geometry.replace('.gltf', '.pcd'),
    },
  };
};
